import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'endWith',
})
export class EndWithPipe implements PipeTransform {
  transform(value: any, endingString: string): any {
    return value == null ? value : value + endingString;
  }
}
